import { Component, OnInit, Input, ElementRef, OnDestroy } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import { TokenService } from "src/app/core/token/token.service";
import { ChatService } from "src/app/services/chat.service";
import { TranslateService } from "@ngx-translate/core";
import { ModalHoraFinalizarChatComponent } from "../modal-hora-finalizar-chat/modal-hora-finalizar-chat.component";
import { Subscription } from "rxjs";

@Component({
  selector: "app-chat-finalizar",
  templateUrl: "./chat-finalizar.component.html",
  styleUrls: ["./chat-finalizar.component.scss"],
})
export class ChatFinalizarComponent implements OnInit, OnDestroy {

  @Input() chatData;
  @Input() socketChat;
  tokenData: any;
  tabulacao: any;
  tabulacaoLista: any;
  comentario: any = '';
  contadores: any;
  selector: string;
  newSubs: Subscription;

  constructor(
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private tokenService: TokenService,
    private chatService: ChatService,
    public translate: TranslateService,
    private elemRef: ElementRef,
    private modalService: NgbModal,
  ) {
    this.selector = elemRef.nativeElement.tagName.toLowerCase();
  }

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]['style']['zoom'] = '0.85'
    this.tokenData = this.tokenService.getAllInfos();
    //console.log(this.chatData)
    this.loadTabulacao();
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  close(result?) {
    if (result) {
      this.activeModal.close(result);
    } else {
      this.activeModal.close();
    }
  }

  loadTabulacao() {
    this.newSubs = this.chatService.getTabulacao(this.chatData.widget.id, true)
      .subscribe((res) => {
        //console.log(res);
        this.tabulacaoLista = res.dropDown
      }, (error) => console.error('loadTabulacao', error))
  }

  changeTabulacao(event) {
    //console.log(event)
    this.tabulacao = event;
  }

  fecharFinalizar(): void {
    this.close();
  }

  openModalFinalizarTarefaChat() {
    const modalRef = this.modalService.open(ModalHoraFinalizarChatComponent, {
      scrollable: false,
      windowClass: "modal-custom-milvus",
      size: "medio",
      keyboard: false,
      backdrop: "static",
    });

    modalRef.componentInstance.chatData = this.chatData;
    modalRef.componentInstance.infoFinalizacao = {
      comentario: this.comentario,
      tabulacao: this.tabulacao
    }

    modalRef.result.then((result) => {
      if (result === 'finalizado') {
        this.close(result)
      }
    });
  }

  salvar() {
    if (this.chatData && this.chatData.chamado_vinculado) {
      if (!this.tabulacao && this.tabulacaoLista.length > 0 || !this.comentario) {
        this.toastr.show(this.translate.instant("PREENCHA_CAMPOS_OBRIGATORIOS"), "", environment.toastrConfig("warning"));
        return;
      }
      this.openModalFinalizarTarefaChat()
    } else {
      if (!this.tabulacao && this.tabulacaoLista.length > 0 || !this.comentario) {
        this.toastr.show(this.translate.instant("PREENCHA_CAMPOS_OBRIGATORIOS"), "", environment.toastrConfig("warning"));
        return;
      }
      let finalizarChat: any = { chat_id: this.chatData._id, tabulacao: this.tabulacao ? this.tabulacao.id : null, comentario: this.comentario };

      if(this.chatData.is_finaliza_pelo_historico){
        finalizarChat.is_finaliza_pelo_historico = this.chatData.is_finaliza_pelo_historico;
      }

      this.chatService.finalizarChat(finalizarChat)
        .subscribe((res) => {
          //console.log(res);
          this.close('finalizado');
        }, (error) => console.error('salvar', error)
      )
    }
  }

  verificarComentario() {
    return this.comentario === '';
  }

}
